import { createFileRoute, redirect } from "@tanstack/react-router";

/** Flyttad till /logga-in – permanent omdirigering som behåller sökparametrar. */
export const Route = createFileRoute("/auth")({
  validateSearch: (s: Record<string, unknown>) => s,
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/logga-in", search: search as never, statusCode: 301 });
  },
});
